// extracted by mini-css-extract-plugin
module.exports = {"RowDisplay":"AvatorWithPR_RowDisplay__3K3ML","AvatorBox":"AvatorWithPR_AvatorBox__1YWVx","DisplayName":"AvatorWithPR_DisplayName__1QxDm"};